import http from './http';

// 分页查询渠道订单
const fetchChanelOrderList = (params) => {
  return http({
    url: '/channel-order/page',
    data: params,
    method: 'POST',
  });
};

// 获取crs订单列表
const fetchCrsOrderList = (params) => {
  return http({
    url: '/crs/queryCrsOrderList',
    data: params,
    method: 'POST',
  });
};

// 获取crs订单详情
const fetchCrsOrderDetail = (params) => {
  return http({
    url: '/crs/orderCrsOrderDetail',
    params,
  });
};

export { fetchCrsOrderList, fetchCrsOrderDetail, fetchChanelOrderList };
